<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            上账单号：<span v-if="formData.finflowNo"
                           style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.finflowNo }}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span v-if="!dataId" class="information"> 制单</span>
            <span v-else-if="formData.stat==1" class="information">待审核</span>
            <span v-else-if="formData.stat==2" class="information">已审核</span>
            <span v-else-if="formData.stat==3" class="information">驳回</span>
            <span v-else-if="formData.stat==99" class="information">做废</span>
            <span v-else class="information"></span>



          </div>
          <div style="display:none">

            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-thumb">指派中心
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-chat-line-square">
              用户催单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-tickets">工单跟进
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-delete">
              关闭工单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-copy">打印工单
            </el-button>


          </div>
          <div class="fr">
            <!-- <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置</el-button> -->
            <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData"
                       v-if="this.formData.stat!=2&&formData.stat!=99&&sfSiteFinflowSave&&showSaveBtn">保存</el-button>
          </div>
        </div>



          <!-- 基本信息 -->
          <dix style="overflow-y: scroll!important;
    height: 100vh!important; ">
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>主信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>

                    <th>
                      <em class="f-red">*</em>
                      上账科目
                    </th>
                    <td>
                      <el-select v-model="formData.finId" placeholder="请选择" clearable>
                        <el-option v-for="item in finSubjectList" :key="item.id" :label="item.finName"
                                   :value="item.id">
                        </el-option>
                      </el-select>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      机构名称
                    </th>
                    <td>
                      <org-search :org-name.sync="formData.orgName"
                                  :org-id-path.sync="formData.orgIdPath"
                                  :org-id.sync="formData.orgId"
                                  @clear="() => {formData.siteId = null; formData.siteName = null}"
                      />
<!--                      <el-cascader-->
<!--                        v-model="orgValue"-->
<!--                        :options="orgOptions"-->
<!--                        @change="orgHandleChange"/>-->
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      网点
                    </th>
                    <td>
                      <site-pop-search :site-id.sync="formData.siteId"
                                       :site-name.sync="formData.siteName"
                                       :org-name.sync="formData.orgName"
                                       :org-id-path.sync="formData.orgIdPath"
                                       :org-id.sync="formData.orgId"
                      />
<!--                      <el-input type="text"-->
<!--                                autocomplete="off"-->
<!--                                v-model="formData.siteName"-->
<!--                                clearable :readonly="true">-->
<!--                        <i slot="suffix" class="el-input__icon el-icon-search"-->
<!--                           @click="showSitePop=true"></i>-->
<!--                      </el-input>-->
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      状态
                    </th>
                    <td>
                      <el-form-item>
                        <el-select v-model="formData.stat"  clearable disabled="true">
                          <el-option label="待审核" :value="1"/>
                          <el-option label="已审核" :value="2"/>
                          <el-option label="驳回" :value="3"/>
                          <el-option label="作废" :value="99"/>
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>

                    <th>
                      <em class="f-red">*</em>
                      金额
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.amount" style="width:  ;"
                                clearable/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      年月
                    </th>
                    <td>
                      <el-date-picker v-model="formData.yearAndMonth" type="month" placeholder="选择年月"
                                      align="right" value-format="yyyy-MM">
                      </el-date-picker>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-item">
                <div class="title first"><b>票据信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      收款银行帐户
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.inBankAccountName" style="width:  ;"
                                clearable/>
                    </td>
                    <th>收款银行帐号</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.inBankAccount" style="width:  ;"
                                clearable/>
                    </td>
                    <th>
                      收款银行名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.inBankName" style="width:  ;"
                                clearable/>
                    </td>
                  </tr>

                  <tr>
                    <th>
                      付款银行帐户
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.outBankAccountName" style="width:  ;"
                                clearable/>
                    </td>
                    <th>付款银行帐号</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.outBankAccount" style="width:  ;"
                                clearable/>
                    </td>
                    <th>
                      付款银行名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.outBankName" style="width:  ;"
                                clearable/>
                    </td>
                  </tr>
                    <tr>
                      <th>票据号码</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.billNo" style="width:  ;"
                                clearable/>
                    </td>
                    <th>手续费</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.serviceChargeAmount" style="width:  ;"
                                clearable/>
                    </td>
                     <th>实际金额</th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.factAmount" style="width:  ;"
                                clearable/>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      支付时间
                    </th>
                    <td>
                      <el-date-picker v-model="formData.payBillDate" type="datetime" placeholder="选择日期时间"
                                      align="right" default-time="12:00:00">
                      </el-date-picker>
                    </td>
                    <th>
                      预计到帐时间
                    </th>
                    <td>
                      <el-date-picker v-model="formData.expectBillDate" type="datetime" placeholder="选择日期时间"
                                      align="right" default-time="12:00:00">
                      </el-date-picker>
                    </td>
                    <th>实际到帐时间</th>
                    <td>
                      <el-date-picker v-model="formData.factBillDate" type="datetime" placeholder="选择日期时间"
                                      align="right" default-time="12:00:00">
                      </el-date-picker>
                    </td>
                  </tr>
                  <tr>
                    <th>图片</th>
                    <td colspan="3">
                      <div class="form_picture">
                        <div>
                          <!-- <el-upload style="display:flex;    flex-direction: row-reverse;justify-content: flex-end;" 
                                     :action="api.uploadFileUrl"
                                    list-type="text"
                                     :on-remove="handleRemove1"
                                     :on-preview="tPreviewf"
                                    :before-upload="(file)=>{beforeUp(file)}"
                                     :file-list="picList"
                                     :on-success="(res,file, fileList) => {handleSuccess(res,file, fileList)}"
                                     :on-change="(files, fileList) => {handleImageChange(fileList)}"
                                     :auto-upload="true" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload> -->
                          <!-- <text-upload :photo-url.sync="formData.pic"/> -->
                          <photoUpload :photo-url.sync="formData.pic"/>


                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>接口对接</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      传单状态
                    </th>
                    <td>
                      <el-form-item>
                        <el-select v-model="formData.sendFlag" style="width:  ;" clearable>
                          <el-option label="未传" :value="0"/>
                          <el-option label="失败" :value="1"/>
                          <el-option label="已传" :value="2"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    <th>
                      传单时间
                    </th>
                    <td>
                      <el-date-picker v-model="formData.sendDate" type="datetime" placeholder="选择日期时间"
                                      align="right" default-time="12:00:00">
                      </el-date-picker>
                    </td>

                  </tr>
              <tr><th>
                      传单备注
                    </th>
                    <td colspan="3">
                      <el-input type="text" autocomplete="off" v-model="formData.sendMessage" clearable/>
                    </td></tr>
                  </tbody>
                </table>
              </div>
              <div style="height:0px"></div>
            </div>
          </dix>
      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>

    <sitePop v-if="showSitePop"
             @commit="siteCommit"
             :visiable.sync="showSitePop"
             multi="true"/>



  </div>
</template>

<script>
import store from "@/store";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import {mapGetters} from "vuex";
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue'
import OrgSearch from "@/components/formItem/orgSearch.vue";
import sitePopSearch from "@/components/formItem/sitePopSearch.vue";
import {Previewf} from './elUpload';
// import textUpload from "@/components/formItem/textUpload.vue"
// 图片
import photoUpload from "@/components/formItem/photoUpload.vue"



export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    showSaveBtn: Boolean
  },
  components: {sitePopSearch, OrgSearch, sitePop,photoUpload},
  data() {
    return {
      // listType:'picture-card',
      // listType:'text',
      pictureType:'picture-card',
      showSitePop: false,
      showOrderPop: false,
      showWarehousePop: false,
      orgOptions: [],
      orgValue: '',
      areaOption: [],
      areaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      shippingMethodList: [],
      logisticsCompaniesList: [],
      picList: [],
      formData: {
        finflowNo: null,  // 上帐单号;前缀"F"+年月日+6位流水号
        orgId: null,  // 所属中心，关联脚手架机构表sys_dept.dept_id
        orgName: null,  // 所属机构名称,冗余字段
        orgIdPath: null,  // 所属机构ID路径,冗余字段.重要
        siteId: null,  // 网点ID,关联sn_user.id;
        finId: null,  // 上帐科目ID,关联bas_fin_subject.id
        amount: 0,  // 金额
        yearAndMonth: null,  // 年月
        stat: 1,  // 状态：1待审核;2已审核;3驳回;99做废
        inBankAccountName: null,  // 收款银行帐户
        inBankAccount: null,  // 收款银行帐号
        inBankName: null,  // 收款银行名称
        outBankAccountName: null,  // 付款银行帐户
        outBankAccount: null,  // 付款银行帐号
        outBankName: null,  // 付款银行名称
        billNo: null,  // 票据号码
        payBillDate: null,  // 支付时间
        expectBillDate: null,  // 预计到帐时间
        factBillDate: null,  // 实际到帐时间
        serviceChargeAmount: 0,  // 手续费
        factAmount: 0,  // 实际金额
        pic: null,  // 凭证图片
        sendFlag: 0,  // 传单状态：0未传;1失败;2已传
        sendDate: null,  // 传单时间
        sendMessage: null,  // 传单备注
      },
      finSubjectList: [],


      show3: false,
      node: true,
      srcList: [],
      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    this.sfSiteFinflowSave= this.permissions["sfSiteFinflowSave"]; //新增保存
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    this.getData()
    this.loadOrgData()
    this.loadFinSubject()
  },

  watch:{
    'formData.amount' : {
      handler(n) {
        this.formData.factAmount = n
      },
      deep: true
    }
  },
  updated(){
    console.log('发生了改变');
  },
  methods: {
    beforeUp(file){
      Previewf(file)
      console.log(this.pictureType,"this.pictureType的值");
    },
    tPreviewf(file) {
      // Previewf(file)
    //   console.log(file);
    // file.response.data.fileName=file.name
    //   window.open(file.url,'hello');
console.log(rr,"rrsadasd");

    },
    loadFinSubject() {
      this.$http({
        url: api.basFinSubject.getListDataUrl,
        method: 'post',
        data: {usable: 1}
      }).then(res => {
        this.finSubjectList = res.data.data
      })
    },

    // 网点弹框选中
    siteCommit(data) {
      console.log('选中的网点', data)
      this.formData.siteId = data.id
      this.formData.siteName = data.name
    },

    // 加载机构数据
    loadOrgData() {
      this.$http({
        url: api.sysDept.getDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        console.log(res.data.data)
        this.orgOptions = []
        res.data.data.forEach(item => {
          let temp = {
            value: item.id,
            label: item.name,
          }
          if (item.hasChild) {
            temp.children = []
            item.child.forEach(item1 => {
              temp.children.push({
                value: item1.deptId,
                label: item1.name
              })
            })
          }
          this.orgOptions.push(temp)
        })
      })
    },

    // 机构选中
    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.orgId = res.data.data.deptId
          this.formData.orgName = res.data.data.name
          this.formData.orgIdPath = res.data.data.orgIdPath
        })
      }
    },


    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            // this.formData.pic = uploadFileFormat(this.picList)
            var url = (this.isEdit ? api.sfSiteFinflow.updateDataUrl : api.sfSiteFinflow.addDataUrl);
            this.$http({
              url: url,
              method: 'post',
              data: this.formData,
              isLoading: true,
            }).then(response => {
              this.$message.success("保存成功！");
              this.reload()
              this.$mask.close()

            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
          });
        }
      });
    },

    getData() {
      console.log('getData')
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.sfSiteFinflow.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          this.formData = data
          this.formData.pic = data.pic
          this.orgValue = data.orgId
          this.echoAddress()
        })
      }
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove1() {
      this.picList = []
    },
    handleSuccess(res, file, fileList) {
      // console.log( file, fileList,"url11")
      // this.picList = echoFileFormat(res.data.url)
      this.picList.url=res.data.url
      this.picList.name=file.name
        // name:file.name
      // })
      console.log(this.picList,"this.picListdezhi");
    },


    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },

    areaconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_area;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            areaName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_area = this.table_area.concat(items);
      }
    },
    preconditionconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_type;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            typeName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_type = this.table_type.concat(items);
      }
    },
    // 删除所选的数据  2表
    handleDelete1_2(index) {
      this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
    },
    AddListRow1_2() {

      this.tenant.snCompanyOrderAttributeDTOS.push({})
    },
    // 上传成功
 
    handleRemove(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn = false;
    },

    // 上传成功
    handleSuccess4(res, file, picIndex) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn4 = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      Vue.set(this.tenant.businessPhoto,)

    },
    handleRemove4(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn4 = false;
    },
    handleDelete2(index) {
      this.table_area.splice(index, 1);
    },
    handleDelete(index) {
      this.table_type.splice(index, 1);
    },

    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
      console.log(fileList, "文件状态改变时")
      console.log(file, "文件状态改变时file")
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  > div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框


// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover > td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}


// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}
// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 7vw !important;
}

#containt .table-detail tbody tr td {
  width: 12vw !important;;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}
#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}

</style>
